
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { State } from "vuex-class";

@Component
export default class ModalDetailAssessment extends Vue {
  @State("locale")
  private locale: any;

  /* PROPS */
  @Prop({default: false})
  private isShow: boolean;
  @Prop({default: {}})
  private data: Object;

  private getAssessmentName(item: any): string {
    if (!item) {
      return "";
    }
    if (this.locale == "id") {
      return item["translation"];
    }
    return item["name"];
  }
}
